import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withTheme, Typography, Icon } from '@material-ui/core';

class FHECard extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired
    };

    render() {
        const { theme } = this.props;
        return (
            <Fragment>
                <Typography
                    style={{
                        padding: 5,
                        fontSize: 18,
                        fontWeight: 'bold',
                        backgroundColor: 'transparent'
                    }}
                >
                    {Translator.translate('general.contact_fullhomeenergy')}
                </Typography>
                <div className="d-flex flex-row mt-3 mb-2">
                    <Icon
                        className="fa fa-envelope mr-2 d-flex align-items-center"
                        style={{
                            fontSize: 18,
                            flex: 0.1,
                            color: theme.palette.primary.main
                        }}
                    />
                    <Typography
                        style={{
                            flex: 0.9,
                            flexDirection: 'row',
                            backgroundColor: 'transparent'
                        }}
                    >
                        {Translator.translate('general.email_support')}
                    </Typography>
                </div>
                <div className="d-flex flex-row mt-3 mb-2">
                    <Icon
                        className="fa fa-phone mr-2 d-flex align-items-center"
                        style={{
                            fontSize: 18,
                            flex: 0.1,
                            color: theme.palette.primary.main
                        }}
                    />
                    <Typography
                        style={{
                            flex: 0.9,
                            flexDirection: 'row',
                            backgroundColor: 'transparent'
                        }}
                    >
                        {Translator.translate('general.phone.cost', Translator.translate('general.phone_number'))}
                    </Typography>
                </div>
                <div className="d-flex flex-row mt-3 mb-2">
                    <Icon
                        className="fa fa-clock mr-2 d-flex align-items-center"
                        style={{
                            fontSize: 18,
                            flex: 0.1,
                            color: theme.palette.primary.main
                        }}
                    />
                    <Typography
                        style={{
                            flex: 0.9,
                            flexDirection: 'row',
                            backgroundColor: 'transparent'
                        }}
                    >
                        {Translator.translate('general.support_hours')}
                    </Typography>
                </div>

                <div className="text-center">
                    <Typography
                        style={{
                            textDecorationLine: 'underline',
                            backgroundColor: 'transparent'
                        }}
                    >
                        {Translator.translate('general.page.title.privacies')}
                    </Typography>
                </div>
            </Fragment>
        );
    }
}

export default withTheme(FHECard);



// WEBPACK FOOTER //
// ./data/components/FHECard.js